module.exports = __webpack_public_path__ + "static/media/binnen_woonkamer_zuid.270bf0c5.jpg";